import { PlayIcon, PauseIcon } from 'assets/icons';
import Button from 'components/ui-components/Button';

const HomepageCarouselPauseButton = ({ isPaused, onClick }) => (
  <Button
    label="Pause"
    data-testid="play-pause-button"
    className={`fl jc-c ai-c homepage-carousel_pause_button ${
      isPaused ? 'play' : 'pause'
    }`}
    handleClick={onClick}>
    {isPaused ? (
      <PlayIcon data-testid="play-icon" />
    ) : (
      <PauseIcon data-testid="pause-icon" />
    )}
  </Button>
);

export default HomepageCarouselPauseButton;
